import type { AlertLevel } from '@/shared/generated'

import React from 'react'

import AnchoringAlertsGroup from './AnchoringAlertsGroup'

type AlerTreeItem = {
	level: AlertLevel
	total: number
	alerts: {
		id: string
		name: string
		anchors: number
	}[]
}
type AnchoringAlertsProps = {
	alertsTree: AlerTreeItem[]
	onNavigate(ids: string[]): void
	onAnalyticsShowNotification?: (kind: AlertLevel) => void
}
export default function AnchoringAlerts({
	alertsTree,
	onNavigate,
	onAnalyticsShowNotification,
}: AnchoringAlertsProps) {
	return (
		<div className='grid gap-3'>
			{alertsTree.map(({ level, alerts, total }) => (
				<AnchoringAlertsGroup
					key={level}
					kind={level}
					count={total}
					alerts={alerts}
					onFilterClick={onNavigate}
					onAnalyticsShowNotification={onAnalyticsShowNotification}
				/>
			))}
		</div>
	)
}
